import { Directive, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NG_VALIDATORS } from '@angular/forms';
import { BaseValidator } from '@tcm-modules/tcm-core.module';

@Directive({
    selector: '[singleValueRequired]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: SingleValueRequiredValidator, multi: true }
    ],
    standalone: false
})
export class SingleValueRequiredValidator extends BaseValidator implements OnChanges {

  @Input('singleValueRequired')
  allValues: string[];

  @Input('singleValueRequired_fieldNames')
  fieldNames: string[];

  constructor() {
    super('singleValueRequired');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.allValues && changes.allValues.isFirstChange()) {
      return;
    }

    this._onChange();
  }

  protected getValidationResult(control: any) {

    if (control.value == undefined)
      return null;

    if (this.allValues.filter((x) => x != undefined).length) {
      return this.buildValidationErrorResult({ fields: this.fieldNames.join(", ") });
    }

    return null;
  }
}
